<template>
  <vs-card class="pl-5 pt-5 pr-1 m-0">
    <div>
      <a href="#" @click="$emit('changeTab','ComponentMatter')">
        <h4 class="title-report font-semibold">Matters</h4>
      </a>
      <p class="text-base font-medium">Listing of matters, status, and accounts receivable. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentMatterResponsible')">
        <h4 class="title-report font-semibold">Matters by Responsible Lawyer</h4>
      </a>
      <p class="text-base font-medium">Listing of matters grouped by responsible Lawyer. <a href="#"></a></p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','ComponentContactInformation')">
        <h4 class="title-report font-semibold">Contact Information</h4>
      </a>
      <p class="text-base font-medium	">Listing of matters with client contact information.<a href="#"></a></p>
    </div>
  </vs-card>
</template>

<script>
export default {
name: "MatterReport"
}
</script>

<style scoped>

</style>
